var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-comp d-flex justify-center line-card animation-opacity"},[_c('h1',{staticClass:"app-title"},[_vm._v(" "+_vm._s(_vm.smsNotData)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }